module.exports = __webpack_public_path__ + "img/single_product_2.46b70746.png";